module.exports = __webpack_public_path__ + "static/media/astar.f28435af.png";